import { getHeaders } from "../utils";
const intKey = process.env.REACT_APP_API_INTERNAL_TOKEN; 

export async function APIGetOrderReviews({orderId, companyId}) {
	try {
		const headers = getHeaders(intKey);
			const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/review/1.0/company/${companyId}/order/${orderId}`, requestOptions);
		const responseObject = await response.json();
		const orderReviews = responseObject?.data;


		if (orderReviews) {
			return orderReviews.reduce((acc, review) => {
				acc[review.id] = review;
				return acc;
			}, {});
		}
		return {};

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIPostOrderReview(orderId, review, user) {
	try {
		const headers = getHeaders(intKey);

		const body = {
			ordersId : orderId,
			name : review?.name,
			createdByUser : user?.id,
			createdByUserName : user?.name,
			createdByCompany : user?.companyId,
			message : review?.message,
			location : (typeof review?.location === 'string') ? JSON.parse(review?.location) : review?.location,
			type: (typeof review?.type !== "undefined") ? review?.type : "question",
			id:review?.id,
			status: review?.status,
			newCreation:review?.newCreation
		};


		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(body),
			redirect: 'follow'
		};


		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/review/1.0/company/${user.companyId}/order/${orderId}`, requestOptions);
		const responseObject = await response.json();
		const orderReview = responseObject?.data;
		return orderReview;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export const APIDeleteOrderReview = async (orderId, reviewId, companyId) => {
	try {
		const headers = getHeaders(intKey);

		const requestOptions = {
			method: 'DELETE',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/review/1.0/company/${companyId}/order/${orderId}/delete/${reviewId}`, requestOptions);
		const responseObject = await response.json();
		const orderReview = responseObject?.data;
		return orderReview;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}